import type { TFunction } from "i18next";
import U2000InfoDialog from "../../../../u2000Core/components/dialog/U2000InfoDialog";

// Typage des props du composant
interface U2104AffiliationShowSecretKeyDlgProps {
  isDialogSecretKeyOpen: boolean;
  secretKey: string;
  onClose: () => void;

  t: TFunction;
  NS: string;
}

// Composant principal pour l'affichage de la clé secrète dans une boîte de dialogue
function U2104AffiliationShowSecretKeyDlg({ isDialogSecretKeyOpen, secretKey, onClose, t, NS }: U2104AffiliationShowSecretKeyDlgProps) {
  if (!isDialogSecretKeyOpen) return null;

  return (
    <U2000InfoDialog width="medium" isOpen={isDialogSecretKeyOpen} title={`${t("lblUser", { ns: NS })} - ${t("user.lblSecretKey", { ns: NS })}`} onClose={onClose}>
      <div className="flex min-h-[48px]  items-center justify-center rounded-sm bg-gray-400 m-4 text-center text-lg font-semibold text-gray-800">{secretKey}</div>
    </U2000InfoDialog>
  );
}

export default U2104AffiliationShowSecretKeyDlg;
